"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEnvConfig = exports.default = void 0;
var _isArray = _interopRequireDefault(require("lodash/isArray"));
var _mergeWith = _interopRequireDefault(require("lodash/mergeWith"));
var _debug = require("../utils/debug");
var _common = _interopRequireDefault(require("./env/common.config"));
var _package = _interopRequireDefault(require("../../package.json"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateFieldGet(receiver, privateMap) { var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "get"); return _classApplyDescriptorGet(receiver, descriptor); }
function _classApplyDescriptorGet(receiver, descriptor) { if (descriptor.get) { return descriptor.get.call(receiver); } return descriptor.value; }
function _classPrivateFieldSet(receiver, privateMap, value) { var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "set"); _classApplyDescriptorSet(receiver, descriptor, value); return value; }
function _classExtractFieldDescriptor(receiver, privateMap, action) { if (!privateMap.has(receiver)) { throw new TypeError("attempted to " + action + " private field on non-instance"); } return privateMap.get(receiver); }
function _classApplyDescriptorSet(receiver, descriptor, value) { if (descriptor.set) { descriptor.set.call(receiver, value); } else { if (!descriptor.writable) { throw new TypeError("attempted to set read only private field"); } descriptor.value = value; } }
var getEnvConfig = exports.getEnvConfig = {
  production: () => require("./env/production.config"),
  development: () => require("./env/staging.config"),
  testing: () => require("./env/testing.config"),
  test: () => require("./env/testing.config"),
  // used by JEST
  staging: () => require("./env/staging.config")
};
var customMerge = (a, b) => (0, _isArray.default)(b) ? b : undefined;
var _config = /*#__PURE__*/new WeakMap();
var _setAtRoot = /*#__PURE__*/new WeakMap();
class Config {
  constructor() {
    _classPrivateFieldInitSpec(this, _config, {
      writable: true,
      value: void 0
    });
    _defineProperty(this, "setEnv", (env, extendedConfig, cb) => {
      var mainConfig = _objectSpread(_objectSpread({
        backendConnectorVersion: _package.default.version,
        initialEnv: env
      }, _common.default), getEnvConfig[env]());
      if (extendedConfig) {
        this.setConfig((0, _mergeWith.default)(mainConfig, extendedConfig, customMerge), cb);
      } else {
        this.setConfig(mainConfig, cb);
      }
    });
    _classPrivateFieldInitSpec(this, _setAtRoot, {
      writable: true,
      value: obj => {
        Object.keys(obj).forEach(key => {
          this[key] = obj[key]; // really really really bad !
        });

        return obj;
      }
    });
    _defineProperty(this, "setConfig", (newConfig, cb) => {
      var _classPrivateFieldGet2;
      if (!newConfig || typeof newConfig !== 'object') return undefined;
      _classPrivateFieldSet(this, _config, _classPrivateFieldGet(this, _setAtRoot).call(this, (0, _mergeWith.default)(_classPrivateFieldGet(this, _config), newConfig, customMerge)));
      if ((_classPrivateFieldGet2 = _classPrivateFieldGet(this, _config)) !== null && _classPrivateFieldGet2 !== void 0 && _classPrivateFieldGet2.mycdebug && typeof window === 'object') {
        (0, _debug.addDebugAttribute)(_classPrivateFieldGet(this, _config), 'config');
      }
      if (typeof cb === 'function') cb(_classPrivateFieldGet(this, _config));
      return _classPrivateFieldGet(this, _config);
    });
    /*
        web issue:
        CLIENT_ENV is the real client env (development/testing/staging...)
        NODE_ENV=development|production
        due to webpack change because NODE_ENV is reserved and can't be overrided
        with custom env (testing, staging...)
    */
    var _env = process.env.CLIENT_ENV || process.env.NODE_ENV || 'production';
    this.setEnv(_env, undefined);
  }
}
var _default = exports.default = new Config();